module.exports = __webpack_public_path__ + "img/Code_Adoption_1920x350_HDR_v1.cba8f76f.jpg";